'use strict';

angular.module('mean.general-tasks').factory('taskListService', ['$filter', 'GeneralTasks', '$q', 'tradeCodeService',
    function($filter, GeneralTasks, $q, tradeCodeService) {
        var get = function(type = false, location = false) {
            var deferred = $q.defer();
            var query = {};
            if (type && location) { query = { 'projectType': type, 'geoLocation': location} }
            GeneralTasks.query(query, function(global_tasks) {
                deferred.resolve(global_tasks);
            });

            return deferred.promise;
        };

        var getByTrade = function(trade) {
            var deferred = $q.defer();

            GeneralTasks.query({'trade': trade}, function(global_tasks) {
                global_tasks = $filter('orderBy')(global_tasks, ['task_code']);
                deferred.resolve(global_tasks);
            });

            return deferred.promise;
        };

        var getByTradeAndType = function(trade, project, userId) {
            var deferred = $q.defer();

            var query = {
                'trade': trade, 
                'geoLocation': project.geoLocation, 
                'projectType': project.projectType,
                'isCustom': project.isCustom, //this value is defaulted to false
                'userId': project.isCustom?userId:null
            }

            GeneralTasks.query(query, function(global_tasks) {
                if(global_tasks.length == 0) {
                    //this didn't work so lets try a isCustom list
                    query.isCustom = true;
                    query.userId = userId;
                    GeneralTasks.query(query, function(global_tasks) {
                        global_tasks = $filter('orderBy')(global_tasks, ['task_code']);
                        deferred.resolve(global_tasks);
                    });
                } else {
                    global_tasks = $filter('orderBy')(global_tasks, ['task_code']);
                    deferred.resolve(global_tasks);
                }
            });

            return deferred.promise;
        };

        var getByTradeName = function(tradeName, project, userId) {
            var deferred = $q.defer();

            getByTradeAndType(tradeCodeService.getCode(tradeName), project, userId).then(function(list) {
                console.log('got the list');
                deferred.resolve(list);
            });

            return deferred.promise;
        };

        return {
          get: get,
          getByTrade: getByTrade,
          getByTradeAndType: getByTradeAndType,
          getByTradeName: getByTradeName
        };
    }
]);


// WEBPACK FOOTER //
// ./packages/custom/general-tasks/public/services/task-list-service.js